import {Provider} from '@oilstone/container';

export default new Provider().register((container) => {
    container.add('navigationSections', ['about', 'research', 'library', 'activities']);
});
